const $ = window.jQuery;
const $window = window.$window || $(window);


const Capabilities = {


  init () {
    var $panels = $('.capabilties .panel');
    if (!$panels.length)
        return;
    
    $panels.each(function(){
      var $this = $(this);
      $this.find('.title').on('click', function(){
        $('.capabilties').addClass('open');
        $panels.removeClass('active');
        $this.addClass('active');
        if($window.width() <= 768){
          $panels.css('min-height','200px');
          $this.css('min-height',$this.find('.copy-scroll').height());
        }
        if($window.width() < 768){
          $this.find('.details').height($this.find('.copy-scroll').height() + 80);
          setTimeout(function(){
            var pos = $this.position();
            $("html, body").animate({ scrollTop: pos.top - 107 });
          },600);
        }
      });
    });
    
    
  
  }


};

export default Capabilities;